<template>
  <v-app>
    <v-app-bar app>
      <v-spacer />
      <v-btn @click="toggleLocale"
        >{{ $t("language") }} ({{ $i18n.locale }})</v-btn
      >
    </v-app-bar>

    <v-main>
      <v-container>
        <h2>{{ $t("searchClaim") }}</h2>
        <v-form @submit.prevent="onSubmit">
          <v-text-field
            v-model="keyword"
            :label="$t('searchClaimPlaceholder')"
            required
          />
          <v-btn type="submit" color="primary" :loading="loading">
            {{ $t("search") }}
          </v-btn>
        </v-form>

        <v-data-table
          v-if="tyreClaimData.length > 0"
          :headers="headers"
          :items="tyreClaimData"
          class="elevation-1 mt-4"
        >
          <template #[`item.tyreImage`]="{ item }">
            <v-btn icon @click="showImage(item.tyreImageUrl, $t('tyreImage'))">
              <v-icon>mdi-attachment</v-icon>
            </v-btn>
          </template>
          <template #[`item.attachment`]="{ item }">
            <v-btn
              icon
              @click="showImage(item.attachmentImageUrl, $t('purchaseReceipt'))"
            >
              <v-icon>mdi-attachment</v-icon>
            </v-btn>
          </template>
          <template #[`item.purchaseDate`]="{ item }">
            {{ formatDate(item.purchaseDate) }}
          </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="50%">
          <v-card>
            <v-card-title>{{ dialogTitle }}</v-card-title>
            <v-card-text>
              <v-img
                :src="dialogImageSrc"
                contain
                max-width="100%"
                max-height="100%"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" text @click="dialog = false">{{
                $t("close")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar v-model="showError" color="error" :timeout="3000">
          {{ errorMessage }}
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { format, parseISO } from "date-fns";

export default {
  name: "TyreClaimReview",
  data() {
    return {
      keyword: "",
      loading: false,
      showError: false,
      errorMessage: "",
      tyreClaimData: [],
      dialog: false,
      dialogImageSrc: "",
      dialogTitle: "",
    };
  },
  computed: {
    headers() {
      return [
        { title: this.$t("name"), value: "name", align: "center" },
        { title: this.$t("email"), value: "email", align: "center" },
        { title: this.$t("phone"), value: "phone", align: "center" },
        {
          title: this.$t("carLicensePlate"),
          value: "vehicleRegistrationNo",
          align: "center",
        },
        {
          title: this.$t("tyreModelAndSize"),
          value: "tireline",
          align: "center",
        },
        { title: this.$t("tireSize"), value: "tireSize", align: "center" },
        {
          title: this.$t("purchaseDate"),
          value: "purchaseDate",
          align: "center",
        },
        {
          title: this.$t("registrationReferenceNumber"),
          value: "referenceNumber",
          align: "center",
        },
        {
          title: this.$t("tyreImage"),
          value: "tyreImage",
          width: "5%",
          sortable: false,
          align: "center",
        },
        {
          title: this.$t("purchaseReceipt"),
          value: "attachment",
          width: "5%",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.searchRegistration();
  },
  methods: {
    toggleLocale() {
      this.$i18n.locale = this.$i18n.locale === "en" ? "zh" : "en";
    },
    formatDate(dateString) {
      if (!dateString) return this.$t("notAvailable");
      try {
        const date = parseISO(dateString);
        return format(date, "dd/MM/yyyy");
      } catch (error) {
        console.error("Error formatting date:", error);
        return this.$t("invalidDate");
      }
    },
    byteArrayToImageSrc(byteArray) {
      if (!byteArray) return "";
      try {
        return `data:image/png;base64,${byteArray}`;
      } catch (error) {
        console.error("Error converting byte array to image:", error);
        const uint8Array = new Uint8Array(byteArray);
        const base64 = btoa(String.fromCharCode.apply(null, uint8Array));
        return `data:image/png;base64,${base64}`;
      }
    },
    showImage(image, title) {
      this.dialog = true;
      this.dialogTitle = title;
      this.dialogImageSrc = image;
    },
    onSubmit() {
      this.searchRegistration();
    },
    async searchRegistration() {
      this.loading = true;
      this.showError = false;
      this.tyreClaimData = [];

      try {
        const response = await axios.get(
          "https://tyremanagementwebhost20240620094429.azurewebsites.net/api/services/app/Configuration/GetTyreClaim",
          {
            params: { keyword: this.keyword || null },
            headers: {
              accept: "text/plain",
              Authorization: "null",
              "X-XSRF-TOKEN":
                "CfDJ8MPgAadcK_ZLh8mY9f_PY3RgCelOsXtqnui4xzhUo2vvrv32_0TX6eiHRscAZQbM1Q2XQXxCaFDnVyqdO2tuJY2W9cAaB1lTAX9LLa5KLizg3tr9ZYc2s75BfxmzjH_Y0UWEbQRdp2L5LvsPvAG6DDc",
            },
          }
        );

        if (response.data?.result?.tyreClaims?.length > 0) {
          this.tyreClaimData = response.data.result.tyreClaims;
        } else {
          throw new Error(this.$t("noTyreClaimDataFound"));
        }
      } catch (error) {
        console.error("Error fetching tyre claim data:", error);
        this.showError = true;
        this.errorMessage = this.$t("failedToFetchData");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper > table {
  width: 100%;
  table-layout: fixed;
}

.v-data-table >>> .v-data-table__wrapper > table > thead > tr > th,
.v-data-table >>> .v-data-table__wrapper > table > tbody > tr > td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
